export function replaceBlankByDash(str: string = ''): string {
  return str.replaceAll(' ', '-');
}

export function toLower(str: string = ''): string {
  return str.toLowerCase();
}
